import { ListGroup, ListGroupItem } from 'components/shared/ListGroup';
import { FC } from 'react';

type OwnProps = {
  requestId?: string;
};

export const RequestId: FC<OwnProps> = ({ requestId }) => {
  if (!requestId) {
    return null;
  }
  return (
    <ListGroup className="mt-3 mb-3 overflow-y-auto" e2e="quote-details">
      <ListGroupItem labelKey="productModification.requestId" className="ps-0 pe-3" e2e="RequestId">
        <span className="fw-bold" data-e2e="RequestId-value">
          {requestId}
        </span>
      </ListGroupItem>
    </ListGroup>
  );
};

RequestId.displayName = 'RequestId';
